import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { createRef, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SystemLoading } from "../../../store/loadingStore";
// 新增國際化數字輸入元件 import
import { Controller } from "react-hook-form";
import FormNumberInput from "../../../components/FormNumberInput";
import FileAttachmentHandler from "./FileAttachmentHandler";

const CycleDataTable = ({
  unit,
  cycle,
  setRows,
  rows,
  control,
  register,
  errors,
  setValue,
  periodList,
  refs,
  handleDeleteImg,
  handleFileChange,
  identifySeq,
  companySeq,
  isEditable,
}) => {
  const { t } = useTranslation();
  const [, loading] = useContext(SystemLoading);

  useEffect(() => {
    const newRows = (periodList[cycle] || [])?.map((period, key) => ({
      period, //計算期間
      amount: "", //數據量
      provingData: "", //佐證資料
      fileExtension: "", //檔案副檔名
    }));
    setRows(newRows);
    newRows?.map((item, key) => {
      // 每次切換 cycle 就將值清空
      setValue(`amount_${key}`, "");
      setValue(`provingData_${key}`, "");
      if (!refs.current.length) {
        refs.current = Array(newRows?.length)
          .fill(null)
          .map((_, i) => refs.current[i] || createRef());
      }
    });
  }, [cycle]);

  const bodyTemplate = (rowData, options) => {
    const rowIndex = options.rowIndex;
    return (
      <FileAttachmentHandler
        id={`provingData_${rowIndex}`}
        data={rowData}
        isEditable={isEditable}
        fileInputRef={refs.current[rowIndex]}
        register={register}
        errors={errors}
        onFileChange={(e) => handleFileChange(e, refs.current[rowIndex], rowIndex)}
        onFileDelete={(e) => handleDeleteImg(e, refs.current[rowIndex], rowIndex, rowData?.fileId)}
        imagePDFWrapperClass="in-table-cell"
        wrapperClass={`${isEditable ? "" : "flex align-items-center justify-content-center"}`}
      />
    );
  };

  const activeTemplate = (data, options) => {
    return (
      <Controller
        name={`amount_${options.rowIndex}`}
        control={control}
        rules={{ required: { value: true, message: t("validation.required") } }}
        render={({ field, fieldState }) => (
          <>
            <FormNumberInput
              value={field.value}
              errors={errors}
              disabled={isEditable}
              onChange={(newValue) => {
                field.onChange(newValue);
                setRows((prevRows) => {
                  const newRows = [...prevRows]; // 複製陣列
                  // 找到要更新的 row，並確保它是不可變更新
                  const rowIndex = options.rowIndex;
                  newRows[rowIndex] = {
                    ...newRows[rowIndex],
                    amount: newValue, // 更新 amount 欄位
                  };
                  return newRows;
                });
              }}
            />
            {fieldState.error && <small className="p-error block mt-1">{fieldState.error.message}</small>}
          </>
        )}
      />
    );
  };

  return (
    <>
      {/* {JSON.stringify(rows)} */}
      <DataTable
        stripedRows
        className="white-data-table hover-highlight no-shadow w-full"
        tableStyle={{ minWidth: "55rem" }}
        footer={
          <span>
            {t("row_count")}: {rows?.length}
          </span>
        }
        value={rows}
        emptyMessage={t("no_rec")}
      >
        <Column field="period" header={t("period")} />
        <Column body={activeTemplate} header={<label className="required">{t("activity_data")}</label>} />
        <Column body={bodyTemplate} header={`${t("attached_picture")}/${t("attachments")}`} />
      </DataTable>
    </>
  );
};

export default CycleDataTable;
